// BestRx — Texas city authority data.
// 16 Texas cities × 3 service hubs × medication pages = SEO authority cluster.

export const CITIES = [
  // Dallas–Fort Worth Metroplex (DFW)
  { slug: "dallas",          name: "Dallas",          state: "TX", region: "DFW",     population: "1.3M",  tier: 1, note: "the heart of North Texas",
    landmarks: ["Downtown Dallas", "Uptown", "Lakewood", "Highland Park", "Bishop Arts", "Deep Ellum", "Klyde Warren Park", "the Arts District"],
    zips: ["75201","75202","75204","75205","75206","75214","75219","75230"] },
  { slug: "houston",         name: "Houston",         state: "TX", region: "Gulf",    population: "2.3M",  tier: 1, note: "the most populous city in Texas",
    landmarks: ["Downtown Houston", "the Medical Center", "Montrose", "the Heights", "River Oaks", "Galleria", "Memorial", "Midtown"],
    zips: ["77002","77004","77005","77006","77007","77008","77019","77024"] },
  { slug: "austin",          name: "Austin",          state: "TX", region: "Central", population: "975K",  tier: 1, note: "Texas's capital and tech corridor",
    landmarks: ["Downtown Austin", "South Congress", "East Austin", "Westlake", "Zilker", "Tarrytown", "Mueller", "the Domain"],
    zips: ["78701","78702","78703","78704","78751","78731","78759"] },
  { slug: "fort-worth",      name: "Fort Worth",      state: "TX", region: "DFW",     population: "950K",  tier: 1, note: "DFW's western anchor and Cowtown",
    landmarks: ["Downtown Fort Worth", "Sundance Square", "the Stockyards", "TCU", "Cultural District", "West 7th"],
    zips: ["76102","76107","76109","76110","76116"] },
  { slug: "plano",           name: "Plano",           state: "TX", region: "DFW",     population: "285K",  tier: 2, note: "Collin County's anchor city",
    landmarks: ["Legacy West", "Downtown Plano", "Shops at Legacy", "Willow Bend", "Stonebriar"],
    zips: ["75023","75024","75025","75074","75075","75093"] },
  { slug: "frisco",          name: "Frisco",          state: "TX", region: "DFW",     population: "230K",  tier: 2, note: "the fastest-growing city in America",
    landmarks: ["The Star", "Stonebriar Centre", "Frisco Square", "the PGA Headquarters"],
    zips: ["75033","75034","75035","75036"] },
  { slug: "mckinney",        name: "McKinney",        state: "TX", region: "DFW",     population: "200K",  tier: 2, note: "one of the most family-friendly cities in the country",
    landmarks: ["Historic Downtown McKinney", "Adriatica Village", "Craig Ranch"],
    zips: ["75069","75070","75071","75072"] },
  { slug: "allen",           name: "Allen",           state: "TX", region: "DFW",     population: "110K",  tier: 2, note: "a North Texas community where wellness and performance meet",
    landmarks: ["Watters Creek", "Allen Premium Outlets", "the Event Center"],
    zips: ["75002","75013"] },
  { slug: "rockwall",        name: "Rockwall",        state: "TX", region: "DFW",     population: "50K",   tier: 3, note: "the lakeside community east of Dallas",
    landmarks: ["Lake Ray Hubbard", "the Harbor", "Downtown Rockwall"],
    zips: ["75032","75087"] },
  { slug: "garland",         name: "Garland",         state: "TX", region: "DFW",     population: "240K",  tier: 2, note: "one of the largest cities in DFW",
    landmarks: ["Downtown Garland Square", "Firewheel Town Center", "Spring Creek"],
    zips: ["75040","75041","75042","75043","75044"] },
  { slug: "irving",          name: "Irving",          state: "TX", region: "DFW",     population: "240K",  tier: 2, note: "home to Las Colinas and DFW Airport",
    landmarks: ["Las Colinas", "the Music Factory", "Mandalay Canal", "Valley Ranch"],
    zips: ["75038","75039","75061","75062","75063"] },
  { slug: "arlington",       name: "Arlington",       state: "TX", region: "DFW",     population: "395K",  tier: 2, note: "DFW's entertainment capital and home to AT&T Stadium",
    landmarks: ["AT&T Stadium", "Globe Life Field", "UTA", "Six Flags", "Entertainment District"],
    zips: ["76001","76010","76011","76012","76013"] },
  { slug: "mesquite",        name: "Mesquite",        state: "TX", region: "DFW",     population: "150K",  tier: 3, note: "Dallas County's southeastern neighbor",
    landmarks: ["Town East Mall", "Mesquite Championship Rodeo"],
    zips: ["75149","75150","75180","75181"] },
  { slug: "richardson",      name: "Richardson",      state: "TX", region: "DFW",     population: "120K",  tier: 2, note: "the heart of the Telecom Corridor",
    landmarks: ["CityLine", "the Telecom Corridor", "UT Dallas", "Galatyn Park"],
    zips: ["75080","75081","75082","75083"] },
  { slug: "lewisville",      name: "Lewisville",      state: "TX", region: "DFW",     population: "115K",  tier: 3, note: "Lake Lewisville's gateway community",
    landmarks: ["Lake Lewisville", "Old Town", "Vista Ridge Mall"],
    zips: ["75056","75067","75077"] },
  { slug: "denton",          name: "Denton",          state: "TX", region: "DFW",     population: "150K",  tier: 2, note: "North Texas's college town and creative hub",
    landmarks: ["the Square", "UNT", "TWU", "Denton Arts District"],
    zips: ["76201","76205","76208","76209","76210"] },
];

export const CITY_BY_SLUG = Object.fromEntries(CITIES.map((c) => [c.slug, c]));

export const SERVICES = {
  "weight-loss": {
    slug: "weight-loss",
    name: "Weight Loss",
    accent: "red",
    hubSlug: "weight-loss",
    h1: (city) => `Medical Weight Loss in ${city}, TX`,
    intro: (city) =>
      `BestRx delivers clinician-prescribed weight-loss programs to ${city} residents — Tirzepatide, Semaglutide, oral GLP-1, MIC+B12 and L-Carnitine — with NO insurance required and new customers starting as low as $35 your first week*. The assessment takes four minutes from your phone. A licensed Texas clinician reviews your file, and your medication ships directly to your home in ${city} from a U.S. compounding pharmacy.`,
    bullets: [
      "Tirzepatide, Semaglutide, oral GLP-1, MIC+B12 and L-Carnitine — all starting under $300/mo.",
      "Texas-licensed clinicians review every program; no chatbots, no scripts.",
      "Discreet shipping anywhere in Texas within 3–5 business days.",
      "No insurance required — flat monthly pricing, cancel anytime.",
    ],
    meds: ["tirzepatide", "semaglutide", "oral-semaglutide", "mic-b12", "l-carnitine"],
    faq: (city) => [
      { q: `Can I get Tirzepatide in ${city}?`, a: `Yes — BestRx is a Texas-licensed telehealth platform that prescribes Tirzepatide, Semaglutide, and oral GLP-1 to ${city} residents and ships directly to your address. No insurance required.` },
      { q: `How much does weight loss medication cost in ${city}?`, a: `New customers start as low as $35 their first week*. After the introductory period, monthly programs range from approximately $199 to $499 depending on medication and dose. We never hide pricing.` },
      { q: "Do I need insurance?", a: "No. BestRx programs are cash-pay and flat-priced — most patients save money compared to insurance copays and deductibles." },
      { q: "How fast does it ship?", a: "Most patients receive their first month within 3–5 business days of clinician approval." },
      { q: `Is BestRx legal in ${city}, Texas?`, a: "Yes. All clinicians prescribing through BestRx are licensed in the state of Texas. Telehealth-prescribed weight-loss medication is fully legal when clinically appropriate." },
    ],
  },
  "mens-health": {
    slug: "mens-health",
    name: "Men's Health",
    accent: "red",
    hubSlug: "mens-health",
    h1: (city) => `Men's Health & TRT in ${city}, TX`,
    intro: (city) =>
      `BestRx connects men in ${city} with licensed Texas clinicians for testosterone optimization, ED treatment, hair restoration, and performance peptides. No waiting rooms, no months-long appointments, no insurance required. New customers start as low as $35 their first week*. Bloodwork at any LabCorp or Quest near you, medication shipped discreetly to your home in ${city}.`,
    bullets: [
      "TRT, enclomiphene, ED treatment, hair, peptides — bloodwork-driven.",
      "Texas-licensed clinicians; quarterly labs and titration included.",
      "Discreet shipping across Texas — no mention of medication on packaging.",
      "Programs from $99/mo. No insurance required.",
    ],
    meds: ["testosterone", "enclomiphene", "tadalafil", "sildenafil", "pt-141", "anastrozole", "brogaine"],
    faq: (city) => [
      { q: `Can I get TRT in ${city}?`, a: `Yes. BestRx clinicians are licensed in Texas and prescribe TRT to qualified ${city} patients based on bloodwork and clinical review.` },
      { q: `How much does TRT cost in ${city}?`, a: `Men's programs start around $99/month after the $35 first-week introductory offer*. We never hide pricing — multiple package tiers are shown clearly on each medication page.` },
      { q: "Where do I get labs?", a: `Any LabCorp or Quest location in or near ${city}. We send the order, you walk in.` },
      { q: "Insurance?", a: "Not required. Flat monthly cash pricing." },
      { q: "Is telehealth-prescribed TRT legal in Texas?", a: "Yes, when clinically appropriate and lab-supported by a Texas-licensed clinician." },
    ],
  },
  "womens-health": {
    slug: "womens-health",
    name: "Women's Health",
    accent: "red",
    hubSlug: "womens-health",
    h1: (city) => `Women's Health & HRT in ${city}, TX`,
    intro: (city) =>
      `BestRx delivers clinician-prescribed programs to women in ${city} — GLP-1 weight loss, hormone balance, libido, hair, and skin. No clinic visits. No insurance required. New customers start as low as $35 their first week*. Take the assessment in four minutes, get clinician review within 24 hours, and start a program designed for female physiology — shipped directly to your home in ${city}.`,
    bullets: [
      "Weight loss · HRT · libido · skin · hair · longevity.",
      "Programs designed around female physiology — not generic scripts.",
      "Texas-licensed clinicians; quarterly lab tracking.",
      "Discreet shipping anywhere in Texas. No insurance required.",
    ],
    meds: ["semaglutide", "tirzepatide", "oral-semaglutide", "pt-141", "dhea", "mic-b12"],
    faq: (city) => [
      { q: `Can I get HRT in ${city}?`, a: `Yes — BestRx clinicians are licensed in Texas and prescribe HRT to ${city} residents based on symptoms and bloodwork.` },
      { q: `How much does GLP-1 cost in ${city}?`, a: `New customers start as low as $35 their first week*. Monthly Semaglutide programs start around $249 and Tirzepatide around $299. Pricing is shown clearly on every medication page.` },
      { q: "Can I do this if I'm perimenopausal?", a: "Yes — many of our patients are. The assessment captures symptoms; your clinician designs the protocol." },
      { q: "Insurance?", a: "Not required. Flat monthly pricing." },
    ],
  },
  "peptides": {
    slug: "peptides",
    name: "Peptides",
    accent: "red",
    hubSlug: "peptides",
    h1: (city) => `Peptide Therapy in ${city}, TX`,
    intro: (city) =>
      `BestRx delivers clinician-prescribed peptides — BPC-157, TB-500, CJC-1295, PT-141 — to ${city} residents. Provider review required, no insurance required, new customers start as low as $35 their first week*. Shipped discreetly to your address from a U.S. compounding pharmacy.`,
    bullets: [
      "BPC-157 · TB-500 · CJC-1295 · PT-141 — provider-prescribed.",
      "Texas-licensed clinicians; pharmacy-compounded.",
      "Discreet shipping anywhere in Texas.",
      "No insurance required.",
    ],
    meds: ["bpc-157", "tb-500", "cjc-1295", "pt-141"],
    faq: (city) => [
      { q: `Can I get BPC-157 in ${city}?`, a: `Yes — BestRx clinicians prescribe BPC-157 and other peptides to qualified ${city} residents based on assessment and provider review.` },
      { q: "How much do peptides cost?", a: "Programs start around $149/month. New customers start as low as $35 their first week*." },
      { q: "Are peptides legal in Texas?", a: "Yes, when prescribed by a licensed clinician and dispensed by a U.S. compounding pharmacy." },
    ],
  },
};

export const SERVICE_LIST = Object.values(SERVICES);
